import { getDefaultHeaders } from "./utils";

const PROCESSING_STAGES = {
  "Stage Initialization": "INIT",
  "Text Extraction": "Extraction",
  "AI Translation": "Translation",
  "Output Generation": "Export",
   "Context Extraction":  "Enrichment",
   "Editing": "Editing",
};

const PROCESSING_STATES = {
  Queued: "Queued",
  "In Process": "In Process",
  "To Review": "Ready for Review",
  Reviewing: "Reviewing",
  Completed: "Completed",
  Error: "Error",
  "Enriching Extraction": "Enriching Extraction",
  "Extracting Context": "Extracting Context",
};

export async function homeTableData(params = {}) {
  let data = [];
  let headers = await getDefaultHeaders();
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.search) queryParams.append('search', params.search);
  if (params.user_id) queryParams.append('user_id', params.user_id);
  if (params.stage) queryParams.append('stage', params.stage);

  const url = `/api/comic-input-files/?${queryParams.toString()}`;

  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    if (jsonResponse) {
      jsonResponse.results.map((el) => {
        let k = {
          id: el.id,
          title: el.comic_issue.series.title,
          issue: el.comic_issue.title,
          volume: el.comic_issue.volume,
          // episode: el.comic_issue.id,
          file_name: el.file_name,
          createdDate: el.datetime_created.slice(0, 10),
          stage: PROCESSING_STAGES[el.processing_stage_display],
          lastUpdated: el.datetime_modified.slice(0, 10),
          status: PROCESSING_STATES[el.processing_state_display],
          L2R: el.comic_issue.L2R,
          userId:el.user,
          created_by:el.email
        };
        data.push(k);
        return el;
      });
      return {
        data: data,
        count: jsonResponse.count,
        next: jsonResponse.next,
        previous: jsonResponse.previous
      };
    }
  } catch (err) {
    console.log("ERROR 12", err);
    return {
      data: [],
      count: 0,
      next: null,
      previous: null,
    };
  }
}

export async function updateComicStage(id, backendStage) {
  const headers = await getDefaultHeaders(true);
  const url = `/api/comic-input-files/${id}/`;

  const requestOptions = {
    method: "PATCH",
    headers,
    body: JSON.stringify({
      processing_stage: backendStage,
    }),
  };

  try {
    const res = await fetch(url, requestOptions);
    if (!res.ok) throw new Error("Failed to update stage");
    return await res.json();
  } catch (err) {
    console.error("Error updating stage:", err);
    throw err;
  }
}